__turbopack_context__.v({
  "body": "drugs-sheet-module__zeTRCG__body",
  "carve": "drugs-sheet-module__zeTRCG__carve",
  "countLine": "drugs-sheet-module__zeTRCG__countLine",
  "extension": "drugs-sheet-module__zeTRCG__extension",
  "eyebrow": "drugs-sheet-module__zeTRCG__eyebrow",
  "h1": "drugs-sheet-module__zeTRCG__h1",
  "hero": "drugs-sheet-module__zeTRCG__hero",
  "heroCopy": "drugs-sheet-module__zeTRCG__heroCopy",
  "heroImage": "drugs-sheet-module__zeTRCG__heroImage",
  "heroScrim": "drugs-sheet-module__zeTRCG__heroScrim",
  "molecularSignature": "drugs-sheet-module__zeTRCG__molecularSignature",
  "sheet": "drugs-sheet-module__zeTRCG__sheet",
  "standfirst": "drugs-sheet-module__zeTRCG__standfirst",
});
